import type { DruidLikeFilter } from '../../../../../../../server/modules/druid';

export type LikeType = 'like';

export default class LikeFilter implements DruidLikeFilter {
  dimension: string;

  field: void;

  fields: void;

  pattern: string;

  type: LikeType;

  values: void;

  constructor(dimension: string, pattern: string) {
    this.type = 'like';
    this.dimension = dimension;
    this.pattern = pattern;
  }
}
export class StartsWithFilter extends LikeFilter {
  constructor(dimension: string, pattern: string) {
    super(dimension, `${pattern}%`);
  }
}
export class EndsWithFilter extends LikeFilter {
  constructor(dimension: string, pattern: string) {
    super(dimension, `%${pattern}`);
  }
}
export class ContainsFilter extends LikeFilter {
  constructor(dimension: string, pattern: string) {
    super(dimension, `%${pattern}%`);
  }
}
